import styled from 'styled-components';
import media from '../../utils/media';
export const BackgroundImage = styled.div.attrs({
    role: 'img',
}) `
  display: block;
  width: 100%;
  height: 100%;
  background-size: cover;
  background-position: center;
  position: absolute;
  top: 0;
  left: 0;
  z-index: -2;

  background-image: ${({ desktopImage }) => `url(${desktopImage && desktopImage.value && desktopImage.value.src})`};

  ${media.mobile} {
    background-image: ${({ mobileImage }) => `url(${mobileImage && mobileImage.value && mobileImage.value.src})`};
  }
`;
